import { API, GRAPHAPI } from "../../consts_path";

const moment = require("moment");

const pageController = {
  display: "",
  url: [],
  value: [],
};

const monthday = (year, month) => {
  if (year !== -1 && month !== -1) {
    const lastday = ["", 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      lastday[2] = 29;
    }
    return lastday[month];
  }
};

const setCropName = (ymd, fer) => {
  const m = `00${ymd.month}`.slice(-2);
  const d = `00${ymd.day}`.slice(-2);
  let match = "";
  if (ymd.year !== -1 && ymd.month !== -1 && ymd.day !== -1) {
    match = fer.filter((f) => {
      const endDate = f.end_date.split(/-/).join("");
      const prevEndDate = f.prev_end_date.split(/-/).join("");
      const selectedDate = parseInt([ymd.year, m, d].join(""), 10);

      if (selectedDate >= prevEndDate && selectedDate <= endDate) {
        return f.crop_detail;
      }
      return null;
    });
  }
  return match.length !== 0 ? match[0].crop_detail : null;
};

const addOneDay = (pday) => {
  const oneDay = moment(pday).add(1, "days").format("YYYY-MM-DD");
  return oneDay;
};

const makeUrlShow = (url, inputid, id) => {
  return url.replace(API.REP.inputid, inputid).replace(API.REP.paramid, id);
};

const makeUrlIndex = (url, inputid) => {
  return url.replace(API.REP.inputid, inputid);
};

const makeUrlGraph = (url, calc_id, output_id) => {
  return url
    .replace(":calculation_id", calc_id)
    .replace(GRAPHAPI.REP.outputid, output_id);
};

const makeVisualPartsUrl = (url, output_id) => {
  return url.replace(GRAPHAPI.REP.outputid, output_id);
};

const round = (float, n = 5) => {
  return Math.floor(float * Math.pow(10, n)) / Math.pow(10, n);
};

const isEmpty = (str) => {
  return !str || 0 === str.length;
};

const toUpperCase = (str) => {
  return str.toUpperCase();
};

const makeUrlSoilInventory = (url, scode) => {
  return url.replace(":scode", scode).replace(":scode.html", `${scode}.html`);
};

export {
  pageController,
  monthday,
  setCropName,
  addOneDay,
  makeUrlShow,
  makeUrlIndex,
  makeUrlGraph,
  round,
  isEmpty,
  toUpperCase,
  makeUrlSoilInventory,
  makeVisualPartsUrl,
};
